import { ZodTypeAny, ZodTypeDef } from 'zod';

export function cloneZod<T extends ZodTypeAny>(zodString: T): T {
  const constructor = zodString.constructor as { new (def: ZodTypeDef): T };
  return new constructor(zodString._def);
}
